import { type PropsWithChildren, useEffect, useState } from "react";

type Theme = "light" | "dark";

function initialTheme(): Theme {
  try {
    return localStorage.getItem("dbvdw-theme") === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
}

export function AuthLayout(
  { children, wide = false }: PropsWithChildren<{ wide?: boolean }>,
) {
  const [theme, setTheme] = useState<Theme>(initialTheme);

  useEffect(() => {
    document.body.classList.add("auth-page");
    document.documentElement.dataset.theme = theme;
    try {
      localStorage.setItem("dbvdw-theme", theme);
    } catch { /* optional */ }
    return () => document.body.classList.remove("auth-page");
  }, [theme]);

  return (
    <>
      <img
        className="app-watermark"
        src="/assets/logo.svg"
        alt=""
        aria-hidden="true"
        width="256"
        height="256"
      />
      <button
        type="button"
        className="secondary theme-toggle icon-btn"
        aria-label="Thema wisselen"
        onClick={() => setTheme((current) => current === "dark" ? "light" : "dark")}
      >
        <span aria-hidden="true">{theme === "dark" ? "◑" : "◐"}</span>
      </button>
      <main className={wide ? "auth-wide" : undefined}>
        <span className="auth-brand">de Boer &amp; v/d Weijde</span>
        {children}
      </main>
    </>
  );
}
